export const helpers = {
     generatePastMonths: () => {
        const currentDate = new Date();
        const startYear = currentDate.getFullYear();
        const startMonth = currentDate.getMonth() + 1;
        const numberOfYears = 8;

        const months = [
            'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
            'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
        ];

        const dateArray = [];
        const totalMonths = numberOfYears * 12;

        for (let i = 0; i < totalMonths; i++) {
            const monthIndex = (startMonth - 1) - i;
            let yearOffset = startYear + Math.floor(monthIndex / 12);
            let actualMonthIndex = monthIndex % 12;
            if (actualMonthIndex < 0) {
                actualMonthIndex += 12;
                yearOffset--;
            }

            // Format date as MM-YYYY
            const monthValue = String(actualMonthIndex + 1).padStart(2, '0');
            dateArray.push({
                value: `${monthValue}-${yearOffset}`, // MM-YYYY
                label: `${months[actualMonthIndex]}/${yearOffset}`,
            });
        }

        return dateArray;
    },

    generateYears: () => {
        return Array.from({ length: 125 }, (_, index) => {
            const currentYear = new Date().getFullYear();
            const year = currentYear - index;
            return { value: year.toString(), label: year.toString() };
        }).filter(option => parseInt(option.value) >= 1900);
    },

    validateGeneratedYears: () => {
        return Array.from({ length: 125 }, (_, index) => {
          const currentYear = new Date().getFullYear();
          return currentYear - index;
        }).filter(year => year >= 1900).map(year => year.toString());
    },

    generateMonths: () => {
        return Array.from({ length: 12 }, (_, index) => ({
            value: index + 1,
            label: new Date(2022, index, 1)
                .toLocaleDateString('pt-PT', { month: 'long' })
                .replace(/^\w/, (c) => c.toUpperCase()), // Capitalize the first letter
        }));
    },

    property_purpose: () => {
        return [
            { value: 'PRIMARY_PROPERTY_RESIDENCE', label: 'Habitação Própria e Permanente' },
            { value: 'SECONDARY_PROPERTY_RESIDENCE', label: 'Habitação Secundária ou Arrendamento' },
            { value: 'predios_rusticos', label: 'Prédios Rústicos' },
            { value: 'predios_urbanos', label: 'Prédios Urbanos e Outras Aquisições Onerosas' },
            { value: 'entidades_paraiso_fiscal', label: 'Adquirentes ou Entidades Residentes em Paraíso Fiscal' },
        ];
    },

    locations: () => {
        return [
            { value: 'CNT', label: 'Portugal Continental' },
            { value: 'MAD', label: 'Região Autónoma da Madeira' },
            { value: 'AZO', label: 'Região Autónoma dos Açores' },
        ];
    },

};
